<template>
  <v-layout flex align-center justify-center>
    <v-flex xs12 sm6 elevation-6>
      <v-toolbar class="py-1 blue">
        <v-toolbar-title class="white--text">
          <h4>Life RTL Password Reset</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-dialog v-model="successdialog" persistent max-width="350">
        <v-card class="text-center">
          <v-card-title class="headline justify-center">Password Reset Successful</v-card-title>
          <v-card-text>
            <h3>Email sent to {{email}}</h3>
          </v-card-text>
          <v-card-text>Please check your email for instructions</v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" v-on:click="navigateRoute('/login')">Return to login page</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="failuredialog" persistent max-width="400">
        <v-card class="text-center">
          <v-card-title class="headline justify-center">Unable to Reset Password</v-card-title>
          <v-card-text>
            <h3>{{email}}<br>does not have a lifertl.com account</h3>
          </v-card-text>
          <v-card-text>Please return to the login page and click <strong>"Register"</strong>.</v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" v-on:click="navigateRoute('/login')">Return to login page</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card>
        <v-card-text class="pt-4">
          <div>
            <v-form @submit.prevent="hello" v-model="valid" ref="form">
              <v-text-field v-model="email" :rules="emailRules" label="Enter your registered email" required></v-text-field>
              <v-layout justify-space-between>
                <v-btn :disabled="!valid" v-on:click="login" class="blue darken-4 white--text">Reset Password</v-btn>
              </v-layout>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: false,
      successdialog: false,
      failuredialog: false,
      email: "",
      emailRules: [
        (v) => !!v || "Cannot be blank",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Email address is incomplete or contains a space",
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$refs.form.$el.submit();
      }
    },
    login() {
      if (this.$refs.form.validate()) {
        let email = this.email;
        axios({
          url: "/api/user/resetpassword/" + email,
          method: "GET",
        })
          .then(() => {
            this.successdialog = true;
          })
          .catch(() => {
            this.failuredialog = true;
          });
      }
    },
    navigateRoute: function (newpath) {
      this.$router.push(newpath, () => {});
    },
  },
};
</script>

<style>
.loginOverlay {
  background: rgba(33, 150, 243, 0.3);
}
</style>
